<template lang="pug">
section
  div
    | The ‘Worker’ (formerly Tier 2) routes
    | are suitable for skilled and long-term workers.
    | There are 5 more specific Worker routes
    | you must choose from when filling
    | in your sponsor licence application.

  br

  ul
    li
      b Skilled Worker (formerly Tier 2 General)
      |
      | - this allows employers to recruit migrants
      | to work in the UK in a specific job.

    br

    div
      | 🚀
      |
      span(style="background: #ccedeb")
        | Nation.better is here to help you
        | to obtain this sponsor licence type!

    br

    li
      b Intra-Company routes
      |
      | suitable for international businesses and

    br

    ul(style="list-style-type: none")
      li
        b Intra-Company Transfer
        |
        | allows transferring
        | of established workers
        | to do a skilled role
        | in an eligible skilled occupation
        | and meet the salary requirements;

      br

      li
        b Intra-Company Graduate Trainee
        |
        | allows transferring
        | of workers to do a role as part of
        | a structured graduate training programme.

    br

    li
      b T2 Sportsperson
      |
      | - for an elite sportsperson or qualified coach
      | who is sponsored in a role
      | where they will make a significant contribution
      | to the development of sport
      | at the highest level in the UK.

    br

    li
      b T2 Minister of Religion
      |
      | - for a person who has a key leading role
      | within their faith-based organisation
      | or a religious order in the UK.

  br

  div
    | You will be able to apply
    | for a combination of these types,
    | using the same application form
    | and a similar bundle of supporting documents;
    | for example, a ‘Skilled Worker’
    | and ‘Intra-Company Transfer’.

  br

  div
    | If you are already a holder
    | of a ‘Skilled Worker’ sponsor licence,
    | you will be able to add another subcategory,
    | for example, the ‘Intra-Company Transfer’ route
    | through the Sponsor Management System (SMS) free of charge.
</template>

<script>
export default {
  name: "sponsor_licence_types",
};
</script>